module.exports = {"bundle_js":"bundle.js","bundle_css":"bundle.css","protocol":"https","rootDomain":"mlsn.ru","apiPrefix":"https://api.mlsn.ru/v2/","gisPrefix":"https://gis.mlsn.ru/","gaTrackingCode":"UA-15088562-2","dfpCode":"319730835","enableAdFox":true,"release":"2.12.2"}


//////////////////
// WEBPACK FOOTER
// ./etc/client-config.json
// module id = 209
// module chunks = 0